import axios from "axios";
import state from "../store";

const baseURL = state.getters.mainAppURL + "menu/";

const deleteMenuItem = (menuItemId) => axios.delete(baseURL + "delete_menu_item/" + menuItemId);
const deleteMenuItemType = (menuItemTypeId) => axios.delete(baseURL + "delete_menu_item_type/" + menuItemTypeId);
const deleteMenuCategory = (categoryId) => axios.delete(baseURL + "delete_menu_category/" + categoryId);
const deleteAddOnItem = (addOnItemId) => axios.delete(baseURL + "delete_add_on_items/" + addOnItemId);
const deleteAddOnCategory = (addOnCategoryId) => axios.delete(baseURL + "delete_add_on_category/" + addOnCategoryId);
const removeMenuItemAddOns = (menuItemAddOnId) => axios.delete( baseURL + "remove_menu_item_add_on/" + menuItemAddOnId)
const removeMenuItemTypeAddOns = (servingAddOnId) => axios.delete( baseURL + "remove_serving_add_on/" + servingAddOnId)
const fetchRestaurantAddonsCsv = (restaurantId) => axios.get(baseURL + "restaurant_add_ons/" + restaurantId)
const fetchBranchMenuCsv = (branchId) => axios.get(baseURL + "download_menu_csv/" + branchId)
const uploadMenuThroughCSV = (branchId, formData, config) => axios.post(baseURL + "save_menu_using_csv/" + branchId, formData, config)
export {
    deleteMenuItem,
    deleteMenuItemType,
    deleteMenuCategory,
    deleteAddOnItem,
    deleteAddOnCategory,
    removeMenuItemAddOns,
    removeMenuItemTypeAddOns,
    fetchRestaurantAddonsCsv,
    fetchBranchMenuCsv,
    uploadMenuThroughCSV
}